import { render } from "./DragAndDropComponent.vue?vue&type=template&id=6eb80118"
import script from "./DragAndDropComponent.vue?vue&type=script&lang=js"
export * from "./DragAndDropComponent.vue?vue&type=script&lang=js"

import "./DragAndDropComponent.vue?vue&type=style&index=0&id=6eb80118&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__